<template>
  <section id="faq" class="faq section-bg">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>سوالات متداول در مورد میکسر حمل بتن</h2>
        <p></p>
      </div>

      <ul class="faq-list">
        <li v-for="item in contentListByCategoryFAQ" :key="item.id">
          <div
            data-bs-toggle="collapse"
            class="question collapsed"
            :href="'#faq' + item.id"
            aria-expanded="false"
          >
            {{ item.title }}
            <i class="bi bi-chevron-down icon-show"></i
            ><i class="bi bi-chevron-up icon-close"></i>
          </div>
          <div
            :id="'faq' + item.id"
            class="collapse"
            data-bs-parent=".faq-list"
            style=""
            v-html="item.des"
          >
          
          </div>
        </li>
      </ul>

      <!-- <ul class="faq-list">     

        <li v-for="item in contentListByCategoryRef" :key="item.id">
          
          <div
            data-bs-toggle="collapse"
            class="collapsed question"
             aria-expanded="false"
            :href="'#faq' + item.id"
          >
            {{ item.title }}
            <i class="bi bi-chevron-down icon-show"></i
            ><i class="bi bi-chevron-up icon-close"></i>
          </div>
          <div
            :id="'#faq' + item.id"
            class="collapse"
            data-bs-parent=".faq-list"
          >
            <p>
              {{ item.des }}
            </p>
          </div>
        </li>
      </ul> -->
      <!-- 
      <ul class="faq-list">
        <li>
          <div
            data-bs-toggle="collapse"
            class="collapsed question"
            href="#faq1"
          >
            کاربردهای تراک میکسر چیست؟
            <i class="bi bi-chevron-down icon-show"></i
            ><i class="bi bi-chevron-up icon-close"></i>
          </div>
          <div id="faq1" class="collapse" data-bs-parent=".faq-list">
            <p>
              تراک میکسر در بیشتر زمینه‌هایی که مربوط به ساخت و ساز می‌شود،
              کاربرد دارد که پروژه‌های ساختمانی و عمرانی از جمله آن‌ها هستند. به
              زبان ساده‌تر، هرجایی که صحبت از تهیه و انتقال بتن باشد، تراک میکسر
              می‌تواند کاربرد داشته باشد. اشاره به این نکته خالی از لطف نیست که
              بیشتر برای پروژه‌های بزرگ از تراک میکسر استفاده می‌شود. علاوه بر
              ساختمان‌سازی، در زمینه‌های زیادی از جمله شهرسازی، ساخت سد، ساخت
              پل، معدن‌کاری و تونل‌سازی از تراک میکسرها استفاده می‌شود. شاید این
              سوال را از خود بپرسید که چرا در تونل‌سازی از بتن استفاده می‌شود؟
              در این باره باید بگوییم که در فرایند ساخت تونل ممکن است فضاهایی
              بلااستفاده باشند و نیاز به پرکردن پیدا کنند. در این صورت، با
              استفاده از تراک میکسر می‌توان بتن را در فضای مورد نظر خالی و آن
              بخش را پر کرد.
            </p>
          </div>
        </li>

        <li>
          <div
            data-bs-toggle="collapse"
            href="#faq2"
            class="collapsed question"
          >
            چند نوع تراک میکسر وجود دارد؟
            <i class="bi bi-chevron-down icon-show"></i
            ><i class="bi bi-chevron-up icon-close"></i>
          </div>
          <div id="faq2" class="collapse" data-bs-parent=".faq-list">
            <p>
              -تراک میکسرهای مجهز به پمپ <br />
              -کامیون‌های میکسر حجمی<br />
              -تراک‌های میکسر سنگین<br />
              -تراک میکسرهای استاندارد؛ رایج‌ترین نوع کامیون میکسر<br />
              -کامیون‌های بچینگ متحرک<br />
              -کامیون میکسر بتن کارگاهی<br />
            </p>
          </div>
        </li>

        <li>
          <div
            data-bs-toggle="collapse"
            href="#faq3"
            class="collapsed question"
          >
            تراک میکسر چه نوع کامیونی است؟
            <i class="bi bi-chevron-down icon-show"></i
            ><i class="bi bi-chevron-up icon-close"></i>
          </div>
          <div id="faq3" class="collapse" data-bs-parent=".faq-list">
            <p>
              تراک‌میکسر یک کامیون مخلوط‌کن است که در زبان فارسی به آن کامیون
              میکسر بتن هم گفته می‌شود. این کامیون‌ها می‌توانند حجم زیادی از بتن
              را در خود نگه داشته به فضای پروژه منتقل کنند. تراک میکسرها
              کامیون‌های ساده‌ای هستند که روی شاسی آن‌ها تجهیزات مربوط به
              مخلوط‌کن قرار می‌گیرد. با توجه به ابعاد تجهیزات، متریال به کار
              رفته در ساخت و مدل کامیون، وزن تراک‌میکسرها بین 9 تا 14 تن است.
              همچنین این کامیون توانایی حمل حداکثر 18 تن بتن را دارند. نکته‌ای
              که درباره تراک‌میکسرها وجود دارد این است که درام یا همان دیگ این
              میکسرها دارای دو نوع است که به این دو نوع، کند و تند گفته می‌شود.
              دیگ‌های کند می‌توانند از 2 تا 5 دور در دقیقه بچرخند. این در حالی
              است که دیگ‌های تند توانایی چرخش بین 7 تا 13 دور در دقیقه را دارند.
            </p>
          </div>
        </li>

        <li>
          <div
            data-bs-toggle="collapse"
            href="#faq4"
            class="collapsed question"
          >
            ظرفیت تراک میکسر‌ها چقدر است؟
            <i class="bi bi-chevron-down icon-show"></i
            ><i class="bi bi-chevron-up icon-close"></i>
          </div>
          <div id="faq4" class="collapse" data-bs-parent=".faq-list">
            <p>
              ظرفیت تراک میکسر‌ها بین 6 و 12 مترمکعب است که تا 8 مترمکعب از
              موتور‌های‌ 4 سیلندر و حداکثر 12 مترمکعب از موتورهای 6 سیلندر
              استفاده‌ می‌شود.
            </p>
          </div>
        </li>
      </ul> -->
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import TextEditor from "@/components/TextEditor.vue";
import Alerts from "@/components/Alerts";
import { dataGridMixin } from "@/components/dataGridMixin";
import Swal from "sweetalert2";

export default {
  components: {
    TextEditor,
    Alerts,
  },
  mixins: [dataGridMixin],
  computed: {
    ...mapGetters({
      contentListByCategoryFAQ: "controlPanelX/contentListByCategoryFAQ",
    }),
  },
  data() {
    return {};
  },
  watch: {
    currentUser() {
      if (this.currentUser != undefined) {
        this.loadData();
      }
    },
  },
  methods: {},
  async created() {
    await this.$store.dispatch(
      "controlPanelX/getContentListByCategoryTitle",
      "FAQ"
    );
  },
  mounted() {},
};
</script>

<style>
</style>